module.exports = __webpack_public_path__ + "img/cover.9a5d90e1.png";